// import CodeMirror from 'codemirror';
// /* global antlr4, AnalyticsQLLexer, AnalyticsQLParser */
// TODO: Implement parser errors etc.
// import '@voicebase/vbql-parser';

// function SyntaxErrorListener() {
//   antlr4.error.ErrorListener.call(this);
//   return this;
// }
// SyntaxErrorListener.prototype = Object.create(antlr4.error.ErrorListener.prototype);
// SyntaxErrorListener.prototype.constructor = SyntaxErrorListener;
// SyntaxErrorListener.INSTANCE = new SyntaxErrorListener();
//
// SyntaxErrorListener.prototype.syntaxError = (
//   recognizer,
//   offendingSymbol,
//   line,
//   column,
//   msg,
//   e
// ) => {
//   console.log(`line ${line}\ncolumn ${column}\nmessage ${msg}`);
// };


// CodeMirror.registerHelper('hint', 'vbql', (editor) => {
//   const cursor = editor.getCursor();
//   const token = editor.getTokenAt(cursor);
//   const chars = new antlr4.InputStream(editor.getInputField().value);
//   const lexer = new AnalyticsQLLexer.AnalyticsQLLexer(chars);
//   const tokens = new antlr4.CommonTokenStream(lexer);
//   const parser = new AnalyticsQLParser.AnalyticsQLParser(tokens);
//   parser.buildParseTrees = true;
//   const listener = new SyntaxErrorListener();
//   parser.removeErrorListeners();
//   parser.addErrorListener(listener);
//   const tree = parser.statement();
//   return {
//     list: [
//       'BEGIN TRANSACTION', 'COMMIT TRANSACTION', 'ROLLBACK TRANSACTION', 'END TRANSACTION',
//       'CREATE CATEGORY', 'DROP CATEGORY', 'UPDATE CATEGORY',
//       'CREATE FUNCTION', 'DROP FUNCTION', 'UPDATE FUNCTION',
//       'WITH HITS', 'WITH HITS INLINE', 'WITH EXTENDED HITS', 'WITH EXTENDED HITS INLINE',
//     ],
//     from: CodeMirror.Pos(cursor.line, token.start),
//     to: CodeMirror.Pos(cursor.line, token.start),
//   };
// });

import React from 'react';
import CodeMirror from 'codemirror';
import columnNames from './columns';

const Pos = CodeMirror.Pos;

function getKeywords(editor) {
  let mode = editor.doc.modeOption;
  if (mode === 'vbql') mode = 'text/x-vbql';
  return CodeMirror.resolveMode(mode).keywords;
}

function addMatches(result, search, wordlist, formatter) {
  function getText(item) {
    return typeof item === 'string' ? item : item.text;
  }

  function match(string, word) {
    const len = string.length;
    const sub = getText(word).substr(0, len);

    // console.log(string, sub)
    return string.toUpperCase() === sub.toUpperCase();
  }

  if (Object.prototype.toString.call(wordlist) === '[object Array]') {
    for (let i = 0; i < wordlist.length; i += 1) {
      if (match(search, wordlist[i])) result.push(formatter(wordlist[i]));
    }
  } else {
    Object.keys(wordlist).forEach((word) => {
      let val = wordlist[word];
      if (!val || val === true) {
        val = word;
      } else {
        val = val.displayText ? { text: val.text, displayText: val.displayText } : val.text;
      }
      if (match(search, val)) {
        result.push(formatter(val));
      }
    });
  }
}

CodeMirror.registerHelper('hint', 'vbql', (editor, options) => {
  const keywords = getKeywords(editor);

  const cur = editor.getCursor();
  const result = [];
  const token = editor.getTokenAt(cur);
  let start;
  let end;
  let search;
  if (token.end > cur.ch) {
    token.end = cur.ch;
    token.string = token.string.slice(0, cur.ch - token.start);
  }

  // let reference = options.referenceFn || (s => '#' + s);
  // let refRe = new RegExp(_.escapeRegExp(reference('SPLITTER'))
  // .replace('SPLITTER', '\\b(\\w*)\\b'))
  if (token.string.match(/^[.`"\w@]\w*$/) || (options.refRe && token.string.match(options.refRe))) {
    search = token.string;
    start = token.start;
    end = token.end;
  } else {
    start = cur.ch;
    end = cur.ch;
    search = '';
  }

  const compoundKeywordBlacklist = [
    'GROUP', 'ORDER', 'INDEXED', 'BY',
    'ALTER',
    'DETACH', 'ATTACH', 'DATABASE',
    'BEGIN', 'COMMIT', 'ROLLBACK', 'END',
    'CREATE', 'DROP', 'UPDATE',
    'WITH', 'EXTENDED', 'HITS', 'INLINE',
  ];
  const compoundKeywordWhitelist = [
    'with extended hits inline', 'with hits inline', 'with extended hits', 'with hits',
  ];

  const allKeywords = compoundKeywordWhitelist.concat(
    Object.keys(keywords)
      .filter(
        (k) => {
          const blacklisted = compoundKeywordBlacklist.includes(k.toUpperCase());
          return k.length > 3 && !blacklisted;
        },
      ),
  )
    .sort();

  addMatches(result, search, allKeywords, w => w.toUpperCase());
  addMatches(result, search, columnNames, w => w);

  return { list: result, from: Pos(cur.line, start), to: Pos(cur.line, end) };
});
